<template>
  <v-card
    class="vf-card"
    :class="{ 'vf-card--reversed': reversed }"
    flat
    :id="'feature-' + feature.id"
  >
    <v-row no-gutters>
      <!-- TEXTO -->
      <v-col
        cols="12"
        md="5"
        :order="$vuetify.breakpoint.smAndDown ? 1 : reversed ? 2 : 1"
        class="vf-text"
      >
        <div class="d-flex align-center mb-2">
          <v-avatar size="34" class="vf-icon mr-3">
            <v-icon size="19" color="white">{{ feature.icon }}</v-icon>
          </v-avatar>
          <v-chip x-small label class="vf-tag" :color="tagColor" dark>
            {{ $t(feature.tag || "release_tag_new") }}
          </v-chip>
        </div>

        <h3 class="vf-title">{{ $t(feature.title) }}</h3>

        <p class="vf-desc" v-html="$t(feature.description)"></p>

        <ul class="vf-list" v-if="feature.items && feature.items.length">
          <li v-for="i in feature.items" :key="i">
            <v-icon size="15" class="vf-check">mdi-check</v-icon>
            <span v-html="$t(i)"></span>
          </li>
        </ul>

        <div v-if="feature.page" class="mt-4">
          <v-btn small rounded outlined color="secondary" @click="goToPage">
            {{ $t("release_go_to_screen") }}
            <v-icon right size="16">mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </v-col>

      <v-col cols="12" md="1" class="hidden-sm-and-down"></v-col>

      <!-- CAPTURA -->
      <v-col
        cols="12"
        md="6"
        :order="$vuetify.breakpoint.smAndDown ? 2 : reversed ? 1 : 2"
        class="vf-shot"
      >
        <a-version-screenshot
          :image="feature.image"
          :version="version"
          :variants="feature.variants"
          :icon="feature.icon"
          :alt="$t(feature.title)"
          @zoom="$emit('zoom', $event)"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import aVersionScreenshot from "@/components/version/aVersionScreenshot";

export default {
  components: { aVersionScreenshot },
  props: {
    feature: {
      type: Object,
      required: true
    },
    version: {
      type: String,
      required: true
    },
    reversed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tagColor() {
      return (this.feature.tag || "release_tag_new") === "release_tag_improved"
        ? "accent"
        : "primary";
    }
  },
  methods: {
    goToPage() {
      this.$router
        .push({
          name: this.feature.page,
          params: { hotel_slug: this.$route.params.hotel_slug }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.vf-card {
  background: transparent !important;
  padding: 26px 0;
}
.vf-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media (min-width: 960px) {
  /* Aire entre la columna de texto y la captura, en los dos sentidos */
  .vf-text {
    padding-right: 18px;
  }
  .vf-shot {
    padding-left: 18px;
  }
  .vf-card--reversed .vf-text {
    padding-right: 0;
    padding-left: 18px;
  }
  .vf-card--reversed .vf-shot {
    padding-left: 0;
    padding-right: 18px;
  }
}
.vf-icon {
  background: linear-gradient(135deg, #2e21bd 0%, #21b5db 100%);
}
.vf-tag {
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 700;
}
.vf-title {
  font-size: 1.35rem;
  line-height: 1.25;
  font-weight: 700;
  color: #1f2540;
  margin-bottom: 8px;
}
.vf-desc {
  color: #5b6180;
  font-size: 0.94rem;
  line-height: 1.55;
  margin-bottom: 10px;
}
.vf-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
.vf-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #3d4360;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 7px;
}
.vf-check {
  color: #1b998b;
  margin-top: 2px;
}
.vf-shot {
  display: flex;
  align-items: center;
}
</style>
